export default {
	cancel: 'Abbrechen',
	chat_widget_context_label: 'Kontext',
	chat_widget_role_assistant: 'Assistant',
	chat_widget_role_user: 'Du',
	common_actions: 'Aktionen',
	common_add: 'Verknüpfen',
	common_back: 'Zurück',
	common_cancel: 'Abbrechen',
	common_claim: 'Übernehmen',
	common_clear: 'Suche löschen',
	common_close: 'Schließen',
	common_copy_url_to_clipboard: 'URL in die Zwischenablage kopieren',
	common_copy_url_to_clipboard_notification: 'Die URL wurde in die Zwischenablage kopiert.',
	common_custom_color_delete_color_scheme_dialog_confirm_message: 'Möchten Sie das Theme wirklich löschen?',
	common_custom_color_delete_color_scheme_dialog_confirm_title: 'Löschen bestätigen',
	common_custom_color_scheme_cancel: 'Abbrechen',
	common_custom_color_scheme_delete: 'Löschen',
	common_custom_color_scheme_save: 'Speichern',
	common_custom_color_scheme_theme_edit_header: 'Theme bearbeiten',
	common_custom_color_scheme_theme_name: 'Theme Name',
	common_custom_color_scheme_theme_name_required: 'Das Feld Theme Name wird benötigt',
	common_date: 'Datum',
	common_delete: 'Löschen',
	common_detail_unavailable_title: 'Eintrag nicht verfügbar',
	common_discard: 'Verwerfen',
	common_do_not_published: 'Verbergen',
	common_edit: 'Bearbeiten',
	common_kanban_activity_count: '{count} Aktivitäten',
	common_kanban_behavior: 'Verhalten',
	common_kanban_board_selection: 'Board-Auswahl',
	common_kanban_empty_board: 'Keine Spalten vorhanden',
	common_kanban_empty_board_hint: 'Wähle eine Abfrage und ein Feld aus der Toolbar',
	common_kanban_empty_lane: 'Keine Einträge',
	common_kanban_favorites: 'Favoriten',
	common_kanban_field_height: 'Feldhöhe',
	common_kanban_lane_tooltip: 'Spalten nach',
	common_kanban_lanes: 'Spalten',
	common_kanban_loading: 'Board wird geladen…',
	common_kanban_multi_fields: 'Mehrfachauswahl-Felder',
	common_kanban_open_list: 'Aktenliste öffnen',
	common_kanban_opt_fields: 'Wertfelder',
	common_kanban_padding: 'Abstand',
	common_kanban_query_tooltip: 'Ausgewählte Abfrage',
	common_kanban_remember_last_board: 'Zuletzt aktives Board merken',
	common_kanban_select_lane: 'Feld wählen',
	common_kanban_select_query: 'Abfrage wählen',
	common_kanban_send_to_bottom: 'An das Ende setzen',
	common_kanban_send_to_top: 'An den Anfang setzen',
	common_kanban_settings: 'Einstellungen',
	common_kanban_show_suppressed: 'Ausgeblendete Spalten anzeigen',
	common_kanban_single_fields: 'Einfachauswahl-Felder',
	common_kanban_toggle_favorite: 'Favorit umschalten',
	common_loading: 'Lade…',
	common_maximize: 'Maximieren',
	common_minimize: 'Minimieren',
	common_module_activity: 'Aktennotiz',
	common_module_appointment: 'Termin',
	common_module_dataset: 'Akte',
	common_module_document: 'Dokument',
	common_module_mail: 'Mail',
	common_module_message: 'Nachricht',
	common_module_note: 'Merkzettel',
	common_module_phonecall: 'Anruf',
	common_module_task: 'Aufgabe',
	common_not_published: 'Verborgen',
	common_ok: 'OK',
	common_open_in_fullscreen: 'Vollbild',
	common_open_in_new_browser_tab: 'In neuem Browser-Tab öffnen',
	common_picker_done: 'Fertig',
	common_picker_search_clear: 'Suche leeren',
	common_pin: 'Anheften',
	common_plan: 'Aufgabe planen',
	common_publish: 'Veröffentlichen',
	common_published: 'Öffentlich',
	common_refresh: 'Aktualisieren',
	common_restore: 'Wiederherstellen',
	common_save: 'Speichern',
	common_search: 'Suchen',
	common_share: 'Teilen',
	common_spam: 'Als Spam markieren',
	common_time: 'Uhrzeit',
	date_time_picker_open_date_picker_aria_label: 'Datumsauswahl öffnen',
	date_time_picker_open_time_picker_aria_label: 'Zeitauswahl öffnen',
	deactivate_favorites_dialog_confirm: 'Shortcuts deaktivieren',
	deactivate_favorites_dialog_message:
		'Sie haben aktive Shortcuts. Möchten Sie diese deaktivieren und das Suchfeld schließen?',
	deactivate_favorites_dialog_subtitle:
		'Die Shortcuts werden nicht gelöscht und können später wieder aktiviert werden.',
	deactivate_favorites_dialog_title: 'Shortcuts deaktivieren?',
	ok: 'OK',
	save: 'Speichern',
};
